import React, { useEffect } from "react";
import { ExclamationCircleFilled } from "@ant-design/icons";
import { Tooltip } from "antd";
// import type { ButtonProps } from "antd/es/button/button";

import { useSimpleModal } from "../../Common/Modal/Simple";
import { useMessageError, useMessageSuccess } from "../../../hooks/common";
import { listAction } from "../../Common/Table";
import { ButtonProps } from "antd/lib/button/Button";
import {
  PhotoTagTableRow,
  usePhotoTagDelete,
} from "../../../hooks/api/photoTags";

interface ActionButtonProps<RequestRes = undefined> {
  record: PhotoTagTableRow;
  buttonProps?: ButtonProps;
  setTableKey?: (newVal: number) => void;
  afterSuccess?: (res?: RequestRes) => void;
}

export default function DeleteTagButton({
  record,
  setTableKey,
  afterSuccess,
  buttonProps,
}: ActionButtonProps) {
  const photoTagDelete = usePhotoTagDelete(record.id);
  const { open, contextHolder } = useSimpleModal();

  useMessageError([photoTagDelete]);
  useMessageSuccess([photoTagDelete], "Tag deleted");

  useEffect(() => {
    if (
      !photoTagDelete.error &&
      !photoTagDelete.loading &&
      photoTagDelete.data
    ) {
      setTableKey?.(Date.now());
      afterSuccess?.();
    }
  }, [
    photoTagDelete.error,
    photoTagDelete.loading,
    photoTagDelete.data,
    setTableKey,
    afterSuccess,
  ]);

  const ActionButton = listAction.delete;

  return (
    <>
      <Tooltip title="Delete photo tag" placement="topRight">
        <ActionButton
          loading={photoTagDelete.loading}
          title="Delete photo tag?"
          onClick={(e: React.MouseEvent) => {
            e.preventDefault();
            open({
              icon: <ExclamationCircleFilled />,
              title: "Delete photo tag?",
              content: (
                <span>Are you sure you want to delete this photo tag? </span>
              ),
              cancelText: "Cancel",
              okText: "Delete",
              okButtonProps: { danger: true },
              onOk: () => photoTagDelete.fetch(),
            });
          }}
          {...buttonProps}
        />
      </Tooltip>
      {contextHolder}
    </>
  );
}
